function normalizeText(value) {
  return String(value || '').trim();
}

function normalizeStringList(value) {
  if (!Array.isArray(value)) {
    return [];
  }

  return [...new Set(value.map((item) => normalizeText(item)).filter(Boolean))];
}

function normalizeUpperList(value) {
  return [...new Set(normalizeStringList(value).map((item) => item.toUpperCase()))];
}

function normalizeLowerList(value) {
  return [...new Set(normalizeStringList(value).map((item) => item.toLowerCase()))];
}

function normalizeNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

export function buildEmptyMarketingEmailCampaignForm() {
  return {
    name: '',
    subject: '',
    htmlBody: '',
    textBody: '',
    countries: [],
    profileStatuses: [],
    languages: [],
  };
}

export function buildMarketingEmailCampaignPayloadFromForm(form) {
  const textBody = normalizeText(form?.textBody);

  return {
    name: normalizeText(form?.name),
    subject: normalizeText(form?.subject),
    htmlBody: String(form?.htmlBody || ''),
    textBody: textBody || null,
    audienceFilters: {
      countries: normalizeUpperList(form?.countries),
      profileStatuses: normalizeStringList(form?.profileStatuses),
      languages: normalizeLowerList(form?.languages),
    },
  };
}

export function validateMarketingEmailCampaignPayload(payload) {
  const errors = {};

  if (!normalizeText(payload?.name)) {
    errors.name = 'Name is required.';
  }

  if (!normalizeText(payload?.subject)) {
    errors.subject = 'Subject is required.';
  }

  if (!normalizeText(payload?.htmlBody)) {
    errors.htmlBody = 'HTML body is required.';
  }

  return errors;
}

export function mapMarketingEmailCampaignDto(item = {}) {
  return {
    uid: normalizeText(item?.uid),
    name: normalizeText(item?.name),
    subject: normalizeText(item?.subject),
    htmlBody: String(item?.htmlBody || ''),
    textBody: item?.textBody === null || item?.textBody === undefined ? null : String(item.textBody),
    status: normalizeText(item?.status || 'draft') || 'draft',
    audienceFilters: item?.audienceFilters && typeof item.audienceFilters === 'object' ? item.audienceFilters : {},
    selectedCount: normalizeNumber(item?.selectedCount),
    queuedCount: normalizeNumber(item?.queuedCount),
    sentCount: normalizeNumber(item?.sentCount),
    failedCount: normalizeNumber(item?.failedCount),
    skippedCount: normalizeNumber(item?.skippedCount),
    sentAt: item?.sentAt || null,
  };
}

export function mapMarketingEmailCampaignResponseToDto(response = {}) {
  return mapMarketingEmailCampaignDto(response?.campaign || response);
}

export function mapMarketingEmailCampaignListResponseToDto(response = {}) {
  const campaigns = Array.isArray(response?.campaigns) ? response.campaigns : [];

  return {
    campaigns: campaigns.map(mapMarketingEmailCampaignDto),
  };
}

export function mapMarketingEmailPreviewResponseToDto(response = {}) {
  return {
    subject: normalizeText(response?.subject),
    htmlBody: String(response?.htmlBody || ''),
    textBody: response?.textBody === null || response?.textBody === undefined ? null : String(response.textBody),
    unsubscribeUrl: normalizeText(response?.unsubscribeUrl),
  };
}
